import React, { useEffect, useState, useRef } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';
import { Divider } from '@mui/material';
import { formatHistoryDate } from '../../api/utils/strings';
import { convert_role_index_to_string } from "../../utils/parameters";
import { useDataProvider } from "../../api/DataProvider";
import Card from '@mui/material/Card';
import imgServerMainUP from "../../assets/icons/serverMain_thin_1.png";
import imgServerMainDOWN from "../../assets/icons/serverMain_thin_2.png";
import imgServerBackupUP from "../../assets/icons/serverBackup_thin_1.png";
import imgServerBackupDOWN from "../../assets/icons/serverBackup_thin_2.png";
import "../../styles/devices/mob_ServerStatus.css";
import { useTranslation } from "react-i18next";

// INFO - lightgreen, WARNING - khaki, ERROR - salmon, Activado - green, UP - green,, default - gray

export function WebInfoDialog(props) {
  const { openDialog, setOpenDialog } = props;
  const { t } = useTranslation("global")

  const { currentUserRole, json_web_info, json_data_USER } = useDataProvider();
  const [ web_info, setWeb_info ] = useState(null);
  const loadAnimation = useRef('');

  useEffect(() => {
    if (json_web_info !== undefined && json_web_info !== null){
        setWeb_info({
            'arr_notifications': json_web_info['arr_notifications'],
            'description': json_web_info['description'] === "" ? "-" : json_web_info['description'],
            'server_status': json_web_info['server_status'] === 0 ? "DOWN" : json_web_info['server_status'],
            'server2_status': json_web_info['server2_status'] === 0 ? "DOWN" : json_web_info['server2_status'],
            'monitor': {
                'access': json_web_info['monitor']['access'] ? t("strButton.activated") : t("strButton.deactivated"),
                'gpu' : json_web_info['monitor']['gpu'] ? t("strButton.activated") : t("strButton.deactivated"),
                'storage' : json_web_info['monitor']['storage'] ? t("strButton.activated") : t("strButton.deactivated")
            },
            'last_modification': json_web_info['last_modification'],
        });
    }
  }, [json_web_info]);

  const handleClose = () => {
    setOpenDialog(false);
  };

  // MOB - Trigger CSS animation on load
  useEffect(() => {
    setTimeout(() => {
      loadAnimation.current = 'sig_Server_Animate';
    }, 1000);    
  }, []);

  // MOB - Get appropiate server icon depending on its state.
  // serverID: 0 = Main, 1 = Backup
  function serverIcon(serverID, state) {
    if (state === 'Activado' || state === 'UP') {
      return serverID === 0 ? imgServerMainUP : imgServerBackupUP;
    } else {
      return serverID === 0 ? imgServerMainDOWN : imgServerBackupDOWN;
    }
  }

  // MOB - Used to customize CSS classes
  function serverActivePointer() {
    const server = [web_info['server_status'], web_info['server2_status']]; //MOB - Only used for readability, could be removed
    if (server[0] === 'Activado' || server[0] === 'UP') {
      return 'Main';
    } else if (server[1] === 'Activado' || server[1] === 'UP'){
      return 'Backup';
    } else {
      return 'None';
    }
  }

  return (
    <>
      {web_info !== null ? (
        <Dialog className='sig_Drawer_SettingsModal_Root sig_Server_SettingsModal_Root' open={openDialog} onClose={handleClose}>
          <DialogTitle className='sig_Drawer_SettingsModal_Title' > {t("sWebInfo.webInfo_title").toUpperCase()} </DialogTitle>

          <DialogContent className='sig_Drawer_SettingsModal_Content sig_Server_Root'>

            <div className='sig_Server_MainContainer'>
              <div className='sig_Server_InfoTitle'> {t("sWebInfo.section_servers").toUpperCase()} </div>
              <div className='sig_Server_StatusContainer'>
                <div className='sig_Server_Status'>              
                    <img 
                    className={`sig_Server_Img${web_info['server_status']} ${loadAnimation.current}`} 
                    src={serverIcon(0,web_info['server_status'])} 
                    alt={`Icono de servidor primario: ${web_info['server_status']}`}
                    /> 
                    <div className='sig_SignModal_PaperTitle'> {t("sWebInfo.field_primary").toUpperCase()} </div>
                    <div className={`sig_Server_Text sig_Server_State${web_info['server_status']}`}>{ web_info['server_status'] }</div>
                </div>
                <div className='sig_Server_Status'> 
                    <img 
                    className={`sig_Server_Img${web_info['server2_status']} ${loadAnimation.current}`} 
                    src={serverIcon(1,web_info['server2_status'])} 
                    alt={`Icono de servidor primario: ${web_info['server2_status']}`}
                    /> 
                    <div className='sig_SignModal_PaperTitle'> {t("sWebInfo.field_secondary").toUpperCase()} </div>
                    <div className={`sig_Server_Text sig_Server_State${web_info['server2_status']}`}>{ web_info['server2_status'] }</div>
                </div>   
                <div className={`sig_Server_Functionality sig_Server_PointTo${serverActivePointer()}`}>
                  <div className='sig_Server_InfoLine'>
                      <div className='sig_Server_Title'> {t("sWebInfo.field_basic")} </div>
                      <div className={`sig_Server_Text sig_Server_State${web_info['monitor']['access']}`}>{ web_info['monitor']['access'] }</div>
                    </div>
                  <div className='sig_Server_InfoLine'>
                    <div className='sig_Server_Title'> {t("sWebInfo.field_storage")} </div>
                    <div className={`sig_Server_Text sig_Server_State${web_info['monitor']['storage']}`}>{ web_info['monitor']['storage'] }</div>
                  </div>
                  <div className='sig_Server_InfoLine'>
                    <div className='sig_Server_Title'> {t("sWebInfo.field_gpu")} </div>
                    <div className={`sig_Server_Text sig_Server_State${web_info['monitor']['gpu']}`}>{ web_info['monitor']['gpu'] }</div>
                  </div>
                  <div className='sig_Server_InfoLine'>
                    <div className='sig_Server_Title'> {t("sWebInfo.field_version")} </div>
                    <div className='sig_Server_Text'>{ web_info['description'] }</div>
                  </div>
                  <div className='sig_Server_InfoLine'>
                    <div className='sig_Server_Title'> {t("sWebInfo.field_last_update")} </div>
                    <div className='sig_Server_Text'>{ formatHistoryDate(web_info['last_modification']) }</div>
                  </div>
                </div>             
              </div>

              <Divider />
              <div className='sig_Server_NotificationRoot'>
                <div className='sig_Server_InfoTitle'> {t("sWebInfo.section_notifications").toUpperCase()} </div>
                {web_info['arr_notifications'].map((item, index) => (
                  <div key={index} className='sig_Server_NotificationContainer'>
                    {
                      item['role'].includes(convert_role_index_to_string(currentUserRole)) ? (
                        <Card className={`sig_Server_NotificationCard sig_Server_Notification${item['type']}`}>
                          <div className='sig_Server_NotificationInner'>
                            <div className='sig_Server_NotificationTitle'>
                              <span>{item['type']}</span>
                            </div>
                            <div className='sig_Server_NotificationSeparator'/>
                            <div className='sig_Server_NotificationText'>
                              <span>{item['description']}</span>
                            </div>
                          </div>
                        </Card>
                      ) : <></> 
                    }
                  </div>
                ))}
              </div>
            </div>

            <DialogActions className="sig_FormDialog_Button">
              <Button onClick={handleClose}> {t("strButton.btn_exit")} </Button>
            </DialogActions>

          </DialogContent>

        </Dialog>
      ):<></>
      }
    </>
  );
}